module.exports = __webpack_public_path__ + "static/media/white-rectangle-measure-icon.f71aa114.svg";